import { GET_CTO_SWEEP } from "../types";
import { getCTOSweep } from "../api/accountsAPI";

export const fetchCTOSweep =
  (page, limit, parameter = "", sort) =>
  async (dispatch) => {
    try {
      let orderby;
      if (sort === undefined) {
        orderby = "matterRef";
      } else {
        if (sort.dir === "asc") {
          orderby = sort.field;
        } else if (sort.dir === "desc") {
          orderby = sort.field + " desc";
        }
      }

      const response = await getCTOSweep(page, limit, parameter, orderby);
      dispatch({
        type: GET_CTO_SWEEP,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: GET_CTO_SWEEP,
        payload: { data: [], total: 0, error: error.message },
      });
    }
  };
